<div class="layers-overlay" *ngIf="isOpen" (click)="close()">
  <div class="layers-modal" (click)="$event.stopPropagation()">

    <!-- HEADER -->
    <div class="modal-header">
      <button class="back-chevron-btn" [appTourAnchor]="'filters.layersClose'" (click)="close()" aria-label="Close">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#101828" stroke-width="2.5"
          stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
      <div class="title-container">
        <h2>Layers</h2>
      </div>
    </div>

    <div class="modal-body">
      <!-- One live entry across every group; tapping applies it, tapping the live one clears it. -->
      <ng-container *ngIf="isHeatMember">
        <h3 class="group-label">Heatmap</h3>
        <div class="layers-grid">
          <div class="layer-item" (click)="onTileTap(heat)" [class.selected]="selected === heat.key">
            <div class="image-container">
              <img [src]="heat.icon" [attr.alt]="heat.label">
            </div>
            <span class="layer-name">{{ heat.label }}</span>
          </div>
        </div>
        <hr class="group-divider" />
      </ng-container>

      <h3 class="group-label">Overlays</h3>
      <div class="layers-grid">
        <div class="layer-item" *ngFor="let tile of fields" (click)="onTileTap(tile)"
          [appTourAnchor]="tileAnchor(tile)" [class.selected]="selected === tile.key">
          <div class="image-container">
            <img [src]="tile.icon" [attr.alt]="tile.label">
          </div>
          <span class="layer-name">{{ tile.label }}</span>
        </div>
      </div>

      <hr class="group-divider" />

      <h3 class="group-label">Layers</h3>
      <div class="layers-grid">
        <div class="layer-item" *ngFor="let tile of pins" (click)="onTileTap(tile)"
          [class.selected]="selected === tile.key">
          <div class="image-container">
            <img [src]="tile.icon" [attr.alt]="tile.label">
          </div>
          <span class="layer-name">{{ tile.label }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
